export default "__VITE_ASSET__BdOCAe11__"